import React from 'react';
import PreviousChallangeLeaderBoardTableComponent from './PreviousChallangeLeaderBoardTableComponent';

function PreviousLeaderboardModal({ show, onClose }) {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4 z-50"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.85)" }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="rounded-3xl border backdrop-blur-xl max-w-[80%] w-full max-h-[90vh] overflow-hidden relative"
        style={{
          backgroundColor: "rgba(17, 24, 39, 0.95)",
          borderColor: "rgba(251, 146, 60, 0.3)",
          boxShadow: "0 8px 32px rgba(251, 146, 60, 0.3)",
        }}
      >
        <div
          className="flex items-center justify-between p-6 border-b"
          style={{ borderColor: "rgba(55, 65, 81, 0.5)" }}
        >
          <h2 className="text-2xl font-bold text-white flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center"
              style={{
                backgroundColor: "#fb923c",
                boxShadow: "0 4px 15px rgba(251, 146, 60, 0.3)",
              }}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            رده بندی امتیازات مراحل قبلی
          </h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-200 hover:scale-110"
            style={{
              backgroundColor: "rgba(251, 146, 60, 0.2)",
              border: "1px solid rgba(251, 146, 60, 0.3)",
            }}
          >
            <svg
              className="w-6 h-6 text-orange-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div
          className="overflow-y-auto pt-16"
          style={{ maxHeight: "calc(90vh - 100px)" }}
        >
          <PreviousChallangeLeaderBoardTableComponent />
        </div>
      </div>
    </div>
  );
}

export default PreviousLeaderboardModal;